
import { useLanguage } from "@/contexts/LanguageContext";

const CancellationPolicyBox = () => {
  const { language } = useLanguage();
  
  const policyText = {
    fr: {
      title: "Politique d'annulation :",
      content: "Annulation gratuite jusqu'à 30 jours avant l'arrivée."
    },
    en: {
      title: "Cancellation policy:",
      content: "Free cancellation up to 30 days before arrival."
    },
    es: {
      title: "Política de cancelación:",
      content: "Cancelación gratuita hasta 30 días antes de la llegada."
    },
    it: {
      title: "Politica di cancellazione:",
      content: "Cancellazione gratuita fino a 30 giorni prima dell'arrivo."
    },
    de: {
      title: "Stornierungspolitik:",
      content: "Kostenlose Stornierung bis zu 30 Tage vor Ankunft."
    },
    nl: {
      title: "Annuleringsbeleid:",
      content: "Gratis annulering tot 30 dagen voor aankomst."
    }
  };
  
  const depositText = {
    fr: {
      title: "Caution :",
      content: "Une caution de 1000€ sera demandée à l'arrivée."
    },
    en: {
      title: "Security deposit:",
      content: "A €1000 security deposit will be required upon arrival."
    },
    es: {
      title: "Depósito de seguridad:",
      content: "Se solicitará un depósito de seguridad de 1000€ a la llegada."
    },
    it: {
      title: "Deposito cauzionale:",
      content: "All'arrivo sarà richiesto un deposito cauzionale di 1000€."
    },
    de: {
      title: "Kaution:",
      content: "Bei der Ankunft wird eine Kaution von 1000€ verlangt."
    },
    nl: {
      title: "Borg:",
      content: "Bij aankomst wordt een borg van 1000€ gevraagd."
    }
  };

  return (
    <div className="bg-villa-sand/50 p-4 rounded-md text-sm space-y-2">
      <p>
        <span className="font-medium">{policyText[language].title}</span>{" "}
        {policyText[language].content}
      </p>
      <p>
        <span className="font-medium">{depositText[language].title}</span>{" "}
        {depositText[language].content}
      </p>
    </div>
  );
};

export default CancellationPolicyBox;
